import axios from "../../axios";
import { API_BASE_URL } from "../../config/api";

const state = {
    car: {},
    code: 200,
    message: "",
    notfound: false,
    notfoundmsg: "",
    unauthorized: false,
    unauthorizedmsg: "",
    loading: false,
    verified: false,
    baseUrl: API_BASE_URL,
};

const getters = {
    getCar: (state) => state.car,
    isVerified: (state) => state.verified,
    isLoading: (state) => state.loading,
    isUnauthorized: (state) => state.unauthorized,
};

const mutations = {
    setCar(state, payload) {
        state.car = payload || {};
    },
    setNotFound(state, flag) {
        state.notfound = flag;
    },
    setNotFoundmsg(state, msg) {
        state.notfoundmsg = msg;
    },
    setUnauthorized(state, flag) {
        state.unauthorized = flag;
    },
    setUnauthorizedmsg(state, msg) {
        state.unauthorizedmsg = msg;
    },
    setCode(state, payload) {
        state.code = payload;
    },
    setMessage(state, payload) {
        state.message = payload;
    },
    setLoading(state, flag) {
        state.loading = flag;
    },
    setVerified(state, flag) {
        state.verified = flag;
    },
    reset(state) {
        state.car = {};
        state.code = 200;
        state.message = "";
        state.notfound = false;
        state.notfoundmsg = "";
        state.unauthorized = false;
        state.unauthorizedmsg = "";
        state.loading = false;
        state.verified = false;
    },
};

const actions = {
    verifyPreviewToken({ commit }, userToken) {
        return axios
            .post(`/verify-user-token`, {
                user_token: userToken,
            })
            .then((response) => {
                const code = response.data && response.data.code;
                const ok =
                    code === 200 ||
                    code === undefined ||
                    response.data === true ||
                    (response.data && response.data.success === true);

                if (ok) {
                    commit("setVerified", true);
                    commit("setUnauthorized", false);
                    commit("setUnauthorizedmsg", "");
                    return response;
                }

                commit("setVerified", false);
                commit("setUnauthorized", true);
                commit(
                    "setUnauthorizedmsg",
                    (response.data && response.data.message) ||
                        "Invalid preview token"
                );
                return Promise.reject(response);
            })
            .catch((error) => {
                commit("setVerified", false);
                commit("setUnauthorized", true);
                const msg =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    (error.data && error.data.message) ||
                    "Invalid preview token";
                commit("setUnauthorizedmsg", msg);
                return Promise.reject(error);
            });
    },

    fetchCarPreview({ commit }, item) {
        return axios
            .get(`/page/car-preview/${item}`)
            .then((response) => {
                if (response.data.code == 404) {
                    commit("setNotFound", true);
                    commit("setNotFoundmsg", response.data.message);
                    commit("setCar", {});
                } else {
                    commit("setNotFound", false);
                    commit("setNotFoundmsg", "");
                    commit(
                        "setCar",
                        (response.data.data && response.data.data.car) ||
                            response.data.data ||
                            {}
                    );
                }
                commit("setCode", response.data.code);
                commit("setMessage", response.data.message);
                return response;
            })
            .catch((error) => {
                commit("setNotFound", true);
                commit("setNotFoundmsg", "something went wrong");
                commit("setCar", {});
                if (
                    error.response &&
                    error.response.data &&
                    Object.keys(error.response.data).length
                ) {
                    for (
                        let i = 0;
                        i < Object.keys(error.response.data).length;
                        i++
                    ) {
                        console.log(
                            Object.values(error.response.data)[i].toString()
                        );
                    }
                }
                return Promise.reject(error);
            });
    },

    async loadPreview({ commit, dispatch }, { slug, previewToken }) {
        commit("reset");
        commit("setLoading", true);

        if (!previewToken) {
            commit("setUnauthorized", true);
            commit("setUnauthorizedmsg", "Preview token is required");
            commit("setLoading", false);
            return Promise.reject(new Error("Preview token is required"));
        }

        try {
            await dispatch("verifyPreviewToken", previewToken);
            await dispatch("fetchCarPreview", slug);
            commit("setLoading", false);
            return true;
        } catch (error) {
            commit("setLoading", false);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    name: "carPreview",
    state,
    getters,
    actions,
    mutations,
};
